<ng-container *transloco="let t; read: 'widgets.widget-add'">
  <div class="xi-modal__container widget-add__container">
    @switch (state) {
      @case ('start') {
        <h2 class="xi-modal__title">{{ t('add-widget') }}</h2>

        <div class="xi-modal__content xi-modal__content--start">
          <div class="widget-add__widget-info-wrapper">
            <h2>{{ t('widget') }}</h2>

            <a
              class="no-style right-align"
              [href]="'https://spotlight-docs.lexalytics.com/docs/widget-types'"
              target="_blank"
            >
              <xi-icon-button icon="info" color="CX" [hasAnimation]="false" [fill]="'no-fill'">
              </xi-icon-button>
            </a>
          </div>

          <xi-list
            [value]="selectedWidget"
            select="single"
            size="large"
            [isFetchingData]="groupFieldsLoading"
          >
            <div slot="children">
              @for (w of availableWidgets; track w) {
                <xi-list-item
                  #widgetListItem
                  [matTooltip]="w.tooltip"
                  [checked]="w === selectedWidget"
                  [disabled]="!!w.disabled"
                  [value]="w"
                  (onItemClick)="selectWidget(w)"
                  [class.kxi-text-600]="w === selectedWidget"
                  [class.kxi-list-item-disabled]="!!w.disabled"
                >
                  <div slot="children">
                    <span>
                      {{ w.buttonLabel }}
                    </span>

                    @if (w.disabled && groupFieldsLoading) {
                      <div class="xi-loader-container__inline-overlay">
                        <xi-animation
                          [height]="45"
                          [width]="45"
                          [loop]="true"
                          animation="cx_loader"
                        ></xi-animation>
                      </div>
                    }
                  </div>
                </xi-list-item>
              }
            </div>
          </xi-list>

          @if (!isNoteWidgetSelected && !isInsightFeedWidgetSelected) {
            @if (!isNoteWidgetSelected && !isInsightFeedWidgetSelected) {
              <h2>{{ t('data-source') }}</h2>
            }

            @if (!isNoteWidgetSelected && !isInsightFeedWidgetSelected) {
              <div class="data-source-selector">
                <app-data-source-chooser
                  [value]="ds"
                  [valuePlaceholder]="t('select-data-source')"
                  [widget]="widget"
                  [accountMetadata]="accountMetadataFields"
                  [dashboard]="dashboard"
                  [dataSources]="widgetEditOptions.dataSources"
                  (datasourceSelected)="selectDatasource($event)"
                ></app-data-source-chooser>

                @if (selectedWidget.customItems && !ds?.isSocial) {
                  <h2>{{ t('items-to-display') }}</h2>

                  <div class="items-to-display-radio-group">
                    <div class="items-to-display-radio-button">
                      <xi-radio
                        value="top"
                        [label]="t('top-items')"
                        name="itemsToDisplayRadio"
                        [(ngModel)]="itemsToDisplay"
                      ></xi-radio>
                    </div>

                    <div class="items-to-display-radio-button">
                      <xi-radio
                        value="custom"
                        [label]="t('custom-items')"
                        name="itemsToDisplayRadio"
                        [(ngModel)]="itemsToDisplay"
                      ></xi-radio>
                    </div>
                  </div>
                }
              </div>
            }
          } @else {
            @if (isNoteWidgetSelected) {
              <h3>{{ t('add-note-text') }}</h3>

              <div class="widget-add__notes-editor-container">
                @if (selectedWidget.type === 'note') {
                  <app-widget-notes-editor [(content)]="note.text"></app-widget-notes-editor>
                }

                @if (selectedWidget.type === 'noteMarkdown') {
                  <app-widget-markdown-editor
                    [(content)]="note.text"
                    mode="edit"
                  ></app-widget-markdown-editor>
                }

                <xi-checkbox
                  [label]="t('include-title')"
                  [(ngModel)]="note.displayTitle"
                ></xi-checkbox>
              </div>
            }

            @if (isInsightFeedWidgetSelected) {
              <app-widget-add-feed-options
                [projectId]="widget.payload.projectId"
                (feedSourceChanged)="onInsightFeedSourceChange($event)"
              ></app-widget-add-feed-options>
            }
          }
        </div>

        <div class="xi-modal__actions">
          <div class="fill-space"></div>

          <xi-default-button
            [text]="t('cancel')"
            fill="text"
            (onClick)="cancel()"
          ></xi-default-button>

          <xi-default-button
            [text]="confirmButtonText"
            [disabled]="!canConfirm"
            (onClick)="makeWidget()"
          ></xi-default-button>
        </div>
      }

      @case ('item-picker') {
        <h2 class="xi-modal__title">
          {{ t('select-items-for', { canSelectMultiple }) }}
          {{ widgetTitle }}
        </h2>

        <div class="xi-modal__content">
          <div class="select-items-content rows-wrapper">
            @if (widget.payload.type !== 'featureScoring') {
              <div class="row">
                @if (widget.payload.type === 'crosstab') {
                  <div>
                    <xi-toggle-switch
                      [label]="t('table-head')"
                      [isLabelInline]="false"
                      size="large"
                      [leftText]="t('row')"
                      [rightText]="t('column')"
                      [changeColorOnToggle]="false"
                      [isToggled]="selectedAxis !== 'row'"
                      (onToggle)="onAxisChanged($event.detail.isToggled)"
                    ></xi-toggle-switch>
                  </div>
                }

                <h2>{{ t('item-type') }}</h2>

                <mat-form-field>
                  <mat-label>{{ t('item-type') }}</mat-label>

                  <mat-select
                    #elementItemTypeInput
                    [value]="analyticItem"
                    (valueChange)="handleAnalyticItemChange($event)"
                  >
                    @for (key of analyticItemTypeKeys; track key) {
                      <mat-optgroup [label]="key">
                        @for (subType of analyticItems[key].subTypes; track subType) {
                          <mat-option
                            [value]="subType"
                            [disabled]="!isAnalyticTypeEnabled(key, subType)"
                            [matTooltip]="getItemToolTip(subType)"
                          >
                            {{ labelFor(key, subType) | titlecase }}
                          </mat-option>
                        }
                      </mat-optgroup>
                    }
                  </mat-select>
                </mat-form-field>

                @if (
                  isSectionMetadataLoaded &&
                  (sectionMetadata.length || widget.payload.selectedSection?.length)
                ) {
                  <app-section-selector
                    [sectionMetadata]="sectionMetadata"
                    [value]="widget.payload.selectedSection"
                    (sectionSelect)="onItemPickerSectionSelected($event)"
                  ></app-section-selector>
                }
              </div>
            } @else {
              <div class="row">
                <h2>{{ t('select-metadata-field') }}</h2>
                <mat-form-field>
                  <mat-label>{{ t('metadata-field') }}</mat-label>
                  <mat-select #elementMetadataInput [(value)]="metadataField">
                    @for (field of dsMetadataFields; track field) {
                      <mat-option [value]="field.name">
                        {{ getFieldLabel(field.name) }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            }

            @if (analyticItem) {
              @if (analyticItem !== 'taxonomy') {
                <div class="row">
                  <h2>{{ t('item') }}</h2>

                  @if (canShowBlank) {
                    <mat-checkbox (change)="toggleBlank($event.checked)" [checked]="isBlankChecked">
                      {{ t('show-blank') }} <span class="blank-count">{{ blankCount }}</span>
                    </mat-checkbox>
                  }

                  <mat-form-field>
                    <span matPrefix>
                      <mat-icon svgIcon="xi_search"></mat-icon>
                    </span>

                    <input
                      #elementItemInput
                      type="text"
                      matInput
                      name="selectedItemInput"
                      autocomplete="off"
                      [placeholder]="searchPlaceholder"
                      [matAutocomplete]="elementSelectedItems"
                      (input)="updateAnalyticItems($event)"
                      [disabled]="!analyticItem"
                    />
                    <mat-autocomplete
                      #elementSelectedItems="matAutocomplete"
                      (optionSelected)="addSelectedItem($event.option.value)"
                    >
                      @for (item of selectedItemAc.filteredResults; track item) {
                        <mat-option [value]="item.key">
                          <div class="widget-add__analytic-item-select">
                            <div class="widget-add__analytic-item-text">
                              <ng-container *appMiddleEllipsize="item.title"></ng-container>
                            </div>

                            <xi-custom-pill
                              color="CX"
                              [text]="item.count | humanizeInt: 0 : 1000"
                            ></xi-custom-pill>
                          </div>
                        </mat-option>
                      }
                    </mat-autocomplete>

                    @if (selectedItemAc.inProgress) {
                      <mat-spinner matSuffix diameter="24"></mat-spinner>
                    }
                  </mat-form-field>
                </div>

                @if (isItemSelected) {
                  <div class="widget-add__last-row">
                    <div class="selected-header">
                      <h2>{{ t('selected') }}</h2>
                    </div>

                    <div class="widget-add__tag-container">
                      @for (item of selectedItems; track item) {
                        <app-lex-xi-tag
                          [text]="formatItemLabel(item)"
                          type="user"
                          [canUserDelete]="true"
                          (onClick)="removeSelectedItem(item)"
                        ></app-lex-xi-tag>
                      }
                    </div>
                  </div>
                }
              } @else {
                <div class="row auto-width">
                  <h2>{{ t('item', { canSelectMultiple }) }}&nbsp;</h2>

                  <app-taxonomy-picker
                    [selectMultiple]="canSelectMultiple"
                    [showUncategorized]="!isSentimentReport"
                    [selectedNodeIds]="originalSelectedItems"
                    [projectId]="widget.payload.projectId"
                    [widgetDataSource]="ds"
                    [selectedSections]="widget.payload.selectedSection"
                    (selectionChange)="onTaxonomySelectionChanged($event)"
                  ></app-taxonomy-picker>
                </div>
              }
            }
          </div>
        </div>

        <div class="xi-modal__actions">
          <div class="fill-space"></div>

          <xi-default-button
            [text]="t('back')"
            fill="text"
            [disabled]="!!this.widgetEditOptions.widget"
            (onClick)="back()"
          ></xi-default-button>

          <xi-default-button
            [text]="confirmButtonText"
            [disabled]="!canConfirmCustomItems"
            (onClick)="confirm()"
          ></xi-default-button>
        </div>
      }

      @case ('metadata-picker') {
        <h2 class="xi-modal__title">{{ metadataPickerTitle }}</h2>

        <div class="xi-modal__content">
          <div class="select-items-content">
            @switch (widget.payload.type) {
              @default {
                <div class="rows-wrapper">
                  <ng-template *ngTemplateOutlet="metadataPicker"></ng-template>
                </div>
              }
              @case ('numericMetadata') {
                <div class="widget-add__numeric-metadata-container">
                  <div class="widget-add__newspaper">
                    <xi-toggle-switch
                      [leftText]="t('no')"
                      [rightText]="t('yes')"
                      color="CX"
                      [label]="t('include-snapshot')"
                      [isLabelLeft]="true"
                      [disabled]="!newspaperProperties.enabled"
                      [isToggled]="widget.payload.newspaper?.show"
                      (onToggle)="onNewspaperToggled($event.detail.isToggled)"
                    ></xi-toggle-switch>

                    <xi-tool-tip-content
                      [tooltip]="newspaperProperties.tooltip"
                    ></xi-tool-tip-content>
                  </div>

                  <app-numeric-metadata-field-selector
                    [fields]="dsMetadataFields"
                    [colorPalette]="data.defaultColorPalette"
                    [projectPalette]="data.projectPalette"
                    [rows]="widget.payload.numericMetadataFields"
                    [hasComparison]="!!widget.payload.comparison"
                    [canSetDecimals]="false"
                    (valueChange)="onNumericMetadataFieldsChanged($event)"
                    (isValid)="onNumericMetadataFieldsIsValid($event)"
                  ></app-numeric-metadata-field-selector>
                </div>
              }
              @case ('breakdown') {
                <div class="widget-add__breakdown-container">
                  <div class="widget-add__breakdown-top-row">
                    <xi-dropdown
                      [label]="t('select-breakdown-field')"
                      [placeholder]="t('select')"
                      select="single"
                      [data]="breakdownFieldSet"
                      [(value)]="breakdownField"
                      (onValueChange)="onBreakdownBreakdownFieldChange($event)"
                    ></xi-dropdown>

                    @if (
                      isSectionMetadataLoaded &&
                      (sectionMetadata.length || widget.payload.selectedSection?.length)
                    ) {
                      <app-section-selector
                        [forFilters]="true"
                        [compact]="true"
                        [sectionMetadata]="sectionMetadata"
                        [value]="widget.payload.selectedSection"
                        (sectionSelect)="onBreakdownSectionSelected($event)"
                      ></app-section-selector>
                    }
                  </div>

                  <div class="widget-add__breakdown-separator"></div>

                  <div class="widget-add__breakdown-metadata-container">
                    <xi-dropdown
                      [label]="t('numeric-metadata')"
                      [placeholder]="t('select')"
                      select="single"
                      [data]="breakdownNumericMetadataFieldSet"
                      [(value)]="breakDownOptions.primary.numericMetadataFieldId"
                      (onValueChange)="
                        onBreakdownNumericMetadataFieldChange($event.detail.selected.id)
                      "
                    ></xi-dropdown>

                    <xi-dropdown
                      [label]="t('scoring-methodology')"
                      [placeholder]="t('select')"
                      select="single"
                      [data]="breakDownOptions.primary.scoringSet"
                      [(value)]="breakDownOptions.primary.scoring"
                      [disabled]="
                        breakDownOptions.primary.numericMetadataFieldId === 'docs' ||
                        breakDownOptions.primary.isMetadataBinary
                      "
                      (onValueChange)="
                        onBreakdownScoringChange(
                          $event.detail.selected.id,
                          breakDownOptions.primary
                        )
                      "
                    ></xi-dropdown>
                    @if (
                      breakDownOptions.primary.scoring === 'bucket' &&
                      hasDefaultBuckets('primary') &&
                      !currentBucketsMatchDefaults('primary')
                    ) {
                      <div class="restore-container">
                        <xi-default-button
                          [text]="t('restore-to-default')"
                          fill="text"
                          [disabled]="currentBucketsMatchDefaults('primary')"
                          (onClick)="restoreBucketsToDefault('primary')"
                        ></xi-default-button>
                      </div>
                    }

                    @if (breakDownOptions.primary.scoring === 'nps') {
                      <app-lex-horizontal-stepper
                        [(value)]="breakDownOptions.primary.min"
                        [scale]="breakdownNpsStepperScaleFrom"
                        size="normal"
                        [label]="t('min')"
                      ></app-lex-horizontal-stepper>

                      <app-lex-horizontal-stepper
                        [(value)]="breakDownOptions.primary.max"
                        [scale]="breakdownNpsStepperScaleTo"
                        size="normal"
                        [label]="t('max')"
                      ></app-lex-horizontal-stepper>
                    }

                    @if (breakDownOptions.primary.scoring === 'box') {
                      <app-lex-horizontal-stepper
                        [(value)]="breakDownOptions.primary.min"
                        [scale]="breakdownBoxStepperScale"
                        size="normal"
                        [label]="t('min')"
                        [canEdit]="false"
                      ></app-lex-horizontal-stepper>

                      <app-lex-horizontal-stepper
                        [(value)]="breakDownOptions.primary.max"
                        [scale]="breakdownBoxStepperScale"
                        size="normal"
                        [label]="t('max')"
                        [canEdit]="false"
                      ></app-lex-horizontal-stepper>

                      <div class="widget-add__breakdown-display-container">
                        <span class="kxi-label">{{ t('display') }}</span>

                        <app-box-scoring-display
                          [data]="breakDownOptions.primary.boxScoringDisplayData"
                          (update)="breakDownOptions.primary.boxScoringDisplayData = $event"
                        ></app-box-scoring-display>
                      </div>
                    }

                    @if (breakDownOptions.primary.scoring === 'bucket') {
                      <div class="widget-add__bucket-editor">
                        <div class="widget-add__bucket-validation-slot">
                          @if (bucketValidationError.primary) {
                            <p class="widget-add__bucket-validation error-message">
                              <xi-icon icon="warning_filled" iconSize="small" color="error">
                              </xi-icon>
                              {{ bucketValidationError.primary }}
                            </p>
                          }
                        </div>

                        <div class="widget-add__bucket-table">
                          <div class="widget-add__bucket-table-header">
                            <div class="kxi-label">{{ t('bucket-name') }}</div>
                            <div class="kxi-label">{{ t('min') }}</div>
                            <div class="kxi-label">{{ t('exclude') }}</div>
                            <div class="kxi-label">{{ t('max') }}</div>
                            <div class="kxi-label">{{ t('exclude') }}</div>
                            <div class="kxi-label">{{ t('color') }}</div>
                            <div></div>
                          </div>

                          @for (
                            bucket of breakDownOptions.primary.fieldBuckets;
                            track $index;
                            let i = $index
                          ) {
                            <div class="widget-add__bucket-table-row">
                              <xi-input-field
                                [(ngModel)]="bucket.bucketName"
                                (onChange)="onBucketsChanged('primary')"
                              ></xi-input-field>

                              <xi-input-field
                                [(ngModel)]="bucket.minimumValue"
                                type="number"
                                (onChange)="onBucketsChanged('primary')"
                              ></xi-input-field>

                              <xi-checkbox
                                color="CX"
                                [label]="''"
                                [checked]="!bucket.includeMinimum"
                                (onChange)="
                                  bucket.includeMinimum = !$event.detail.target.checked;
                                  onBucketsChanged('primary')
                                "
                              ></xi-checkbox>

                              <xi-input-field
                                [(ngModel)]="bucket.maximumValue"
                                type="number"
                                (onChange)="onBucketsChanged('primary')"
                              ></xi-input-field>

                              <xi-checkbox
                                color="CX"
                                [label]="''"
                                [checked]="!bucket.includeMaximum"
                                (onChange)="
                                  bucket.includeMaximum = !$event.detail.target.checked;
                                  onBucketsChanged('primary')
                                "
                              ></xi-checkbox>

                              <xi-color-picker
                                [selectedColor]="bucket.color"
                                [preselectedColors]="bucketProjectPalette"
                                (onColorChange)="
                                  bucket.color = $event.detail.color; onBucketsChanged('primary')
                                "
                              ></xi-color-picker>

                              <xi-icon-button
                                icon="cancel_circle"
                                fill="text"
                                (onClick)="onDeleteBucket('primary', i)"
                              ></xi-icon-button>
                            </div>
                          }

                          <div class="widget-add__bucket-editor-add-button">
                            <xi-default-button
                              [text]="t('add-bucket')"
                              iconLeft="add_circle"
                              fill="text"
                              (onClick)="onAddBucket('primary')"
                            ></xi-default-button>
                          </div>
                        </div>
                      </div>
                    }

                    @if (breakdownSecondaryAxisAdded) {
                      <div class="fake-icon-wrapper">
                        <xi-icon-button icon="cancel_circle" fill="text"></xi-icon-button>
                      </div>
                    }
                  </div>

                  @if (breakdownCanAddSecondaryAxis) {
                    <div class="widget-add__breakdown-metadata-container__secondary-axis">
                      @if (breakdownSecondaryAxisAdded) {
                        <xi-dropdown
                          [label]="t('numeric-metadata')"
                          [placeholder]="t('select')"
                          select="single"
                          [data]="breakdownSecondaryNumericMetadataFieldSet"
                          [(value)]="breakDownOptions.secondary.numericMetadataFieldId"
                          (onValueChange)="
                            onAdditionalBreakdownNumericMetadataFieldChange(
                              $event.detail.selected.id,
                              true
                            )
                          "
                        ></xi-dropdown>

                        <xi-dropdown
                          [label]="t('scoring-methodology')"
                          [placeholder]="t('select')"
                          select="single"
                          [data]="breakDownOptions.secondary.scoringSet"
                          [(value)]="breakDownOptions.secondary.scoring"
                          [disabled]="
                            breakDownOptions.secondary.numericMetadataFieldId === 'docs' ||
                            breakDownOptions.secondary.isMetadataBinary
                          "
                          (onValueChange)="
                            onAdditionalBreakdownScoringChange(
                              $event.detail.selected.id,
                              breakDownOptions.secondary
                            )
                          "
                        ></xi-dropdown>

                        @if (
                          breakDownOptions.secondary.scoring === 'bucket' &&
                          hasDefaultBuckets('secondary') &&
                          !currentBucketsMatchDefaults('secondary')
                        ) {
                          <xi-default-button
                            [text]="t('restore-to-default')"
                            fill="text"
                            [disabled]="currentBucketsMatchDefaults('secondary')"
                            (onClick)="restoreBucketsToDefault('secondary')"
                          ></xi-default-button>
                        }

                        @if (breakDownOptions.secondary.scoring === 'nps') {
                          <app-lex-horizontal-stepper
                            [(value)]="breakDownOptions.secondary.min"
                            [scale]="breakdownNpsStepperScaleFrom"
                            size="normal"
                            [label]="t('min')"
                          ></app-lex-horizontal-stepper>

                          <app-lex-horizontal-stepper
                            [(value)]="breakDownOptions.secondary.max"
                            [scale]="breakdownNpsStepperScaleTo"
                            size="normal"
                            [label]="t('max')"
                          ></app-lex-horizontal-stepper>
                        }

                        @if (breakDownOptions.secondary.scoring === 'box') {
                          <app-lex-horizontal-stepper
                            [(value)]="breakDownOptions.secondary.min"
                            [scale]="breakdownBoxStepperScale"
                            size="normal"
                            [label]="t('min')"
                            [canEdit]="false"
                          ></app-lex-horizontal-stepper>

                          <app-lex-horizontal-stepper
                            [(value)]="breakDownOptions.secondary.max"
                            [scale]="breakdownBoxStepperScale"
                            size="normal"
                            [label]="t('max')"
                            [canEdit]="false"
                          ></app-lex-horizontal-stepper>

                          <div class="widget-add__breakdown-display-container">
                            <span class="kxi-label">{{ t('display') }}</span>
                            <app-box-scoring-display
                              [data]="breakDownOptions.secondary.boxScoringDisplayData"
                              (update)="breakDownOptions.secondary.boxScoringDisplayData = $event"
                            ></app-box-scoring-display>
                          </div>
                        }

                        @if (breakDownOptions.secondary.scoring === 'bucket') {
                          <div class="widget-add__bucket-editor">
                            <div class="widget-add__bucket-validation-slot">
                              @if (bucketValidationError.secondary) {
                                <p class="widget-add__bucket-validation error-message">
                                  <xi-icon icon="warning_filled" iconSize="small" color="error">
                                  </xi-icon>
                                  {{ bucketValidationError.secondary }}
                                </p>
                              }
                            </div>

                            <div class="widget-add__bucket-table">
                              <div class="widget-add__bucket-table-header">
                                <div class="kxi-label">{{ t('bucket-name') }}</div>
                                <div class="kxi-label">{{ t('min') }}</div>
                                <div class="kxi-label">{{ t('exclude') }}</div>
                                <div class="kxi-label">{{ t('max') }}</div>
                                <div class="kxi-label">{{ t('exclude') }}</div>
                                <div class="kxi-label">{{ t('color') }}</div>
                                <div></div>
                              </div>

                              @for (
                                bucket of breakDownOptions.secondary.fieldBuckets;
                                track bucket;
                                let i = $index
                              ) {
                                <div class="widget-add__bucket-table-row">
                                  <xi-input-field
                                    [(ngModel)]="bucket.bucketName"
                                    (onChange)="onBucketsChanged('secondary')"
                                  ></xi-input-field>

                                  <xi-input-field
                                    [(ngModel)]="bucket.minimumValue"
                                    type="number"
                                    (onChange)="onBucketsChanged('secondary')"
                                  ></xi-input-field>

                                  <xi-checkbox
                                    color="CX"
                                    [label]="''"
                                    [checked]="!bucket.includeMinimum"
                                    (onChange)="
                                      bucket.includeMinimum = !$event.detail.target.checked;
                                      onBucketsChanged('secondary')
                                    "
                                  ></xi-checkbox>

                                  <xi-input-field
                                    [(ngModel)]="bucket.maximumValue"
                                    type="number"
                                    (onChange)="onBucketsChanged('secondary')"
                                  ></xi-input-field>

                                  <xi-checkbox
                                    color="CX"
                                    [label]="''"
                                    [checked]="!bucket.includeMaximum"
                                    (onChange)="
                                      bucket.includeMaximum = !$event.detail.target.checked;
                                      onBucketsChanged('secondary')
                                    "
                                  ></xi-checkbox>

                                  <xi-color-picker
                                    [selectedColor]="bucket.color"
                                    [preselectedColors]="bucketProjectPalette"
                                    (onColorChange)="
                                      bucket.color = $event.detail.color;
                                      onBucketsChanged('secondary')
                                    "
                                  ></xi-color-picker>

                                  <xi-icon-button
                                    icon="cancel_circle"
                                    fill="text"
                                    (onClick)="onDeleteBucket('secondary', i)"
                                  ></xi-icon-button>
                                </div>
                              }

                              <xi-default-button
                                [text]="t('add-bucket')"
                                fill="text"
                                iconLeft="add_circle"
                                (onClick)="onAddBucket('secondary')"
                              ></xi-default-button>
                            </div>
                          </div>
                        }
                      } @else {
                        @if (breakdownNumericMetadataFieldSet?.length >= 1) {
                          <xi-default-button
                            [text]="t('add-numeric-metadata')"
                            fill="text"
                            iconLeft="add_circle"
                            (onClick)="breakdownSecondaryAxisAdded = true"
                          ></xi-default-button>
                        }
                      }

                      @if (breakdownSecondaryAxisAdded) {
                        <div class="secondary-axis-remove-wrapper">
                          <xi-icon-button
                            icon="cancel_circle"
                            fill="text"
                            (onClick)="cancelSecondaryAxis()"
                          ></xi-icon-button>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            }
          </div>
        </div>
        <div class="xi-modal__actions">
          <xi-default-button
            [text]="t('back')"
            fill="text"
            [disabled]="!!this.widgetEditOptions.widget"
            (onClick)="back()"
          ></xi-default-button>

          <xi-default-button
            [text]="confirmButtonText"
            [disabled]="!canConfirmMetadata"
            (onClick)="confirm()"
          ></xi-default-button>
        </div>
      }
    }
  </div>

  <ng-template #metadataPicker>
    <div class="row">
      <h2>{{ t('select-metadata-field') }}</h2>

      <mat-form-field>
        <mat-label>{{ t('metadata-field') }}</mat-label>

        <mat-select #elementMetadataInput [(value)]="metadataField">
          @for (field of dsMetadataFields; track field) {
            <mat-option [value]="field.name">
              {{ getFieldLabel(field.name) }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </ng-template>
</ng-container>
